import React, { useState, useEffect } from "react";
import {
  Search,
  Plus,
  LogOut,
    Trash2,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import "../Styles/communitymember.css";
import { Pencil } from "lucide-react";
import Swal from "sweetalert2";
import * as XLSX from "xlsx";

const API_BASE_URL = "";

// ---- Dummy data (used when the API is unreachable, so the UI can be
// previewed before the backend endpoints exist) ----
const DUMMY_MEMBERS = [
  { id: 1, fullName: "Sanjay M", designation: "UI/UX Designer", company: "Inypeople Technologies", contact: "9840112233", personalEmail: "sanjay.m@gmail.com", officialEmail: "sanjay@inypeople.com", industry: "IT", gender: "Male", linkedIn: "https://linkedin.com/in/sanjaym", state: "Tamil Nadu", city: "Chennai" },
  { id: 2, fullName: "Priya Raghavan", designation: "HR Manager", company: "Zoho Corporation", contact: "9884456712", personalEmail: "priya.r@gmail.com", officialEmail: "priya.raghavan@zoho.com", industry: "Software", gender: "Female", linkedIn: "https://linkedin.com/in/priyar", state: "Tamil Nadu", city: "Chennai" },
  { id: 3, fullName: "Arun Kumar", designation: "Talent Acquisition Lead", company: "Freshworks", contact: "9791234567", personalEmail: "arun.kumar@gmail.com", officialEmail: "arun.k@freshworks.com", industry: "SaaS", gender: "Male", linkedIn: "https://linkedin.com/in/arunk", state: "Tamil Nadu", city: "Chennai" },
  { id: 4, fullName: "Divya Shree", designation: "Product Manager", company: "TCS", contact: "9600123456", personalEmail: "divya.shree@gmail.com", officialEmail: "divya.shree@tcs.com", industry: "IT Services", gender: "Female", linkedIn: "https://linkedin.com/in/divyashree", state: "Tamil Nadu", city: "Coimbatore" },
  { id: 5, fullName: "Karthik Raja", designation: "Software Engineer", company: "Infosys", contact: "9843211098", personalEmail: "karthik.raja@gmail.com", officialEmail: "karthik.r@infosys.com", industry: "IT Services", gender: "Male", linkedIn: "https://linkedin.com/in/karthikraja", state: "Karnataka", city: "Bengaluru" },
  { id: 6, fullName: "Meena Iyer", designation: "L&D Specialist", company: "Cognizant", contact: "9600988776", personalEmail: "meena.iyer@gmail.com", officialEmail: "meena.iyer@cognizant.com", industry: "IT Services", gender: "Female", linkedIn: "https://linkedin.com/in/meenaiyer", state: "Tamil Nadu", city: "Chennai" },
  { id: 7, fullName: "Vignesh Babu", designation: "Recruiter", company: "Wipro", contact: "9840099887", personalEmail: "vignesh.babu@gmail.com", officialEmail: "vignesh.b@wipro.com", industry: "IT Services", gender: "Male", linkedIn: "https://linkedin.com/in/vigneshbabu", state: "Tamil Nadu", city: "Chennai" },
  { id: 8, fullName: "Anitha Suresh", designation: "HR Business Partner", company: "HCL Technologies", contact: "9884433221", personalEmail: "anitha.suresh@gmail.com", officialEmail: "anitha.s@hcl.com", industry: "IT Services", gender: "Female", linkedIn: "https://linkedin.com/in/anithasuresh", state: "Tamil Nadu", city: "Chennai" },
  { id: 9, fullName: "Rahul Nair", designation: "Data Analyst", company: "Accenture", contact: "9791122334", personalEmail: "rahul.nair@gmail.com", officialEmail: "rahul.nair@accenture.com", industry: "Consulting", gender: "Male", linkedIn: "https://linkedin.com/in/rahulnair", state: "Kerala", city: "Kochi" },
  { id: 10, fullName: "Swathi Ramesh", designation: "Content Strategist", company: "Freshworks", contact: "9600334455", personalEmail: "swathi.ramesh@gmail.com", officialEmail: "swathi.r@freshworks.com", industry: "SaaS", gender: "Female", linkedIn: "https://linkedin.com/in/swathiramesh", state: "Tamil Nadu", city: "Chennai" },
  { id: 11, fullName: "Bala Subramaniam", designation: "DevOps Engineer", company: "Zoho Corporation", contact: "9843367788", personalEmail: "bala.s@gmail.com", officialEmail: "bala.s@zoho.com", industry: "Software", gender: "Male", linkedIn: "https://linkedin.com/in/balasubramaniam", state: "Tamil Nadu", city: "Chennai" },
  { id: 12, fullName: "Keerthana V", designation: "UX Researcher", company: "Inypeople Technologies", contact: "9600556677", personalEmail: "keerthana.v@gmail.com", officialEmail: "keerthana.v@inypeople.com", industry: "IT", gender: "Female", linkedIn: "https://linkedin.com/in/keerthanav", state: "Tamil Nadu", city: "Chennai" },
  { id: 13, fullName: "Prasanna Venkat", designation: "Sales Manager", company: "TCS", contact: "9884211334", personalEmail: "prasanna.venkat@gmail.com", officialEmail: "prasanna.v@tcs.com", industry: "IT Services", gender: "Male", linkedIn: "https://linkedin.com/in/prasannavenkat", state: "Tamil Nadu", city: "Chennai" },
  { id: 14, fullName: "Lavanya Krishnan", designation: "Marketing Lead", company: "Freshworks", contact: "9791456789", personalEmail: "lavanya.k@gmail.com", officialEmail: "lavanya.k@freshworks.com", industry: "SaaS", gender: "Female", linkedIn: "https://linkedin.com/in/lavanyakrishnan", state: "Tamil Nadu", city: "Chennai" },
  { id: 15, fullName: "Gokul Anand", designation: "QA Engineer", company: "Cognizant", contact: "9840667788", personalEmail: "gokul.anand@gmail.com", officialEmail: "gokul.a@cognizant.com", industry: "IT Services", gender: "Male", linkedIn: "https://linkedin.com/in/gokulanand", state: "Tamil Nadu", city: "Madurai" },
];

// Slice of DUMMY_MEMBERS used only as an offline fallback so pagination
// still "works" visually if the API is unreachable during preview.
function paginateDummy(all, page, limit, search) {
  const q = search.toLowerCase().trim();
  const filtered = q
    ? all.filter((m) =>
        [m.fullName, m.designation, m.company, m.contact, m.personalEmail,
         m.officialEmail, m.industry, m.gender, m.state, m.city]
          .filter(Boolean)
          .some((field) => field.toLowerCase().includes(q))
      )
    : all;
  const total = filtered.length;
  const start = (page - 1) * limit;
  return {
    members: filtered.slice(start, start + limit),
    total,
    page,
    limit,
    totalPages: Math.max(1, Math.ceil(total / limit)),
  };
}

export default function CommunityMembersList() {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deleteTarget, setDeleteTarget] = useState(null); // holds the member id pending delete

  const [selected, setSelected] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [query, setQuery] = useState("");

  const [pageSize, setPageSize] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalMembers, setTotalMembers] = useState(0);

  const [addingOpen, setAddingOpen] = useState(false);
  const [addForm, setAddForm] = useState({});
  const [saving, setSaving] = useState(false);

  const [editingMember, setEditingMember] = useState(null);
  const [editForm, setEditForm] = useState({});

  // Debounce search input so we're not hitting the DB on every keystroke
  const [debouncedQuery, setDebouncedQuery] = useState("");
  useEffect(() => {
    const t = setTimeout(() => setDebouncedQuery(query), 350);
    return () => clearTimeout(t);
  }, [query]);

  // Reset to page 1 whenever the page size or search term changes
  useEffect(() => {
    setCurrentPage(1);
  }, [pageSize, debouncedQuery]);

  const fetchMembers = async () => {
    try {
      setLoading(true);
      const params = new URLSearchParams({
        page: currentPage,
        limit: pageSize,
      });
      if (debouncedQuery) params.set("search", debouncedQuery);

      const res = await fetch(`${API_BASE_URL}/api/community-members?${params.toString()}`);
      if (!res.ok) throw new Error("Failed to load community members");
      const data = await res.json();

      setMembers(data.members || []);
      setTotalPages(data.totalPages || 1);
      setTotalMembers(data.total || 0);
      setError(null);
    } catch (err) {
      // API not reachable yet — fall back to dummy data so the UI can be previewed
      console.warn("Falling back to dummy community members:", err.message);
      const fallback = paginateDummy(DUMMY_MEMBERS, currentPage, pageSize, debouncedQuery);
      setMembers(fallback.members);
      setTotalPages(fallback.totalPages);
      setTotalMembers(fallback.total);
      setError(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, debouncedQuery]);

  useEffect(() => {
    if (currentPage > totalPages) setCurrentPage(totalPages);
  }, [totalPages, currentPage]);

  const goToPage = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    if (totalPages <= maxVisible + 2) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }
    pages.push(1);
    let start = Math.max(2, currentPage - 1);
    let end = Math.min(totalPages - 1, currentPage + 1);
    if (start > 2) pages.push("dots-start");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < totalPages - 1) pages.push("dots-end");
    pages.push(totalPages);
    return pages;
  };

  const toggleAll = () => {
    setSelectAll((v) => !v);
    setSelected(selectAll ? [] : members.map((m) => m.id));
  };

  const toggleOne = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const confirmDelete = (id) => {
  setDeleteTarget(id);
};

const cancelDelete = () => {
  setDeleteTarget(null);
};

const handleDelete = async (id) => {
  const result = await Swal.fire({
    title: "Delete Community Member?",
    text: "Are you sure you want to delete this member? This action cannot be undone.",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#e0432c",
    cancelButtonColor: "#6c757d",
    confirmButtonText: "Yes, Delete",
    cancelButtonText: "No",
  });

  if (!result.isConfirmed) return;

  try {
    const res = await fetch(`${API_BASE_URL}/api/community-members/${id}`, {
      method: "DELETE",
    });
    if (!res.ok) throw new Error("Failed to delete");
    await fetchMembers();
    Swal.fire({
      title: "Deleted!",
      text: "The member has been deleted.",
      icon: "success",
      timer: 1500,
      showConfirmButton: false,
    });
  } catch (err) {
    console.error(err);
    Swal.fire({
      title: "Error",
      text: "Failed to delete community member. Please try again.",
      icon: "error",
    });
  }
};

  // ---- Add new member ----
  const openAddModal = () => {
    setAddForm({
      fullName: "",
      designation: "",
      company: "",
      contact: "",
      personalEmail: "",
      officialEmail: "",
      industry: "",
      gender: "",
      linkedIn: "",
      state: "",
      city: "",
    });
    setAddingOpen(true);
  };
  const closeAddModal = () => {
    setAddingOpen(false);
    setAddForm({});
  };
  const handleAddChange = (e) => {
    const { name, value } = e.target;
    setAddForm((prev) => ({ ...prev, [name]: value }));
  };
  const handleAddSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/community-members`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(addForm),
      });
      if (!res.ok) throw new Error("Failed to add community member");
      setCurrentPage(1);
      await fetchMembers();
      closeAddModal();
    } catch (err) {
      console.error(err);
      alert("Failed to add community member. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  // ---- Edit member ----
  const openEditModal = (m) => {
    setEditingMember(m);
    setEditForm({
      fullName: m.fullName || "",
      designation: m.designation || "",
      company: m.company || "",
      contact: m.contact || "",
      personalEmail: m.personalEmail || "",
      officialEmail: m.officialEmail || "",
      industry: m.industry || "",
      gender: m.gender || "",
      linkedIn: m.linkedIn || "",
      state: m.state || "",
      city: m.city || "",
    });
  };
  const closeEditModal = () => {
    setEditingMember(null);
    setEditForm({});
  };
  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({ ...prev, [name]: value }));
  };
  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const res = await fetch(
        `${API_BASE_URL}/api/community-members/${editingMember.id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(editForm),
        }
      );
      if (!res.ok) throw new Error("Failed to update community member");
      await fetchMembers();
      closeEditModal();
    } catch (err) {
      console.error(err);
      alert("Failed to save changes. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  const memberFields = [
    { name: "fullName", label: "Full Name", type: "text" },
    { name: "designation", label: "Designation", type: "text" },
    { name: "company", label: "Company", type: "text" },
    { name: "contact", label: "Contact Number", type: "text" },
    { name: "personalEmail", label: "Personal Email", type: "email" },
    { name: "officialEmail", label: "Official Email", type: "email" },
    { name: "industry", label: "Industry", type: "text" },
    { name: "gender", label: "Gender", type: "text" },
    { name: "linkedIn", label: "LinkedIn Profile URL", type: "text" },
    { name: "state", label: "State", type: "text" },
    { name: "city", label: "City", type: "text" },
  ];
  const handleExportToExcel = () => {
  if (members.length === 0) {
    Swal.fire({
      icon: "info",
      title: "No Data",
      text: "There are no community members to export.",
    });
    return;
  }

  const excelData = members.map((m, index) => ({
    "S.No": (currentPage - 1) * pageSize + index + 1,
    "Name": m.fullName || "",
    "Designation": m.designation || "",
    "Company": m.company || "",
    "Contact": m.contact || "",
    "Personal Email": m.personalEmail || "",
    "Official Email": m.officialEmail || "",
    "Industry": m.industry || "",
    "Gender": m.gender || "",
    "LinkedIn": m.linkedIn || "",
    "State": m.state || "",
    "City": m.city || "",
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);

  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(
    workbook,
    worksheet,
    "Community Members"
  );

  XLSX.writeFile(
    workbook,
    "community_members.xlsx"
  );
};

  return (
    <div className="cml-app">
      {/* ---------------- Main content ---------------- */}
      <main className="cml-main">
        

        <section className="cml-panel">
          <div className="cml-controls">
            <label className="cml-show-entries">
              Show Entries :
              <select value={pageSize} onChange={(e) => setPageSize(Number(e.target.value))}>
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </label>

            <span className="cml-pill cml-pill--total">Total Members : {totalMembers}</span>

          <button
  className="cml-pill cml-pill--export"
  onClick={handleExportToExcel}
>
  <span className="cml-excel-icon-wrap">
    <img
      src="/assets/excel.png"
      alt="Excel"
      className="cml-excel-icon cml-excel-icon--default"
    />
    <img
      src="/assets/excel-white.png"
      alt="Excel"
      className="cml-excel-icon cml-excel-icon--hover"
    />
  </span>
  Export To Excel
</button>

            

            <div className="cml-search">
              <Search size={14} />
              <input
                placeholder="Search..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
              />
            </div>
          </div>

          <div className="cml-table-outer">
            <div className="cml-table-inner">
            {loading ? (
              <p style={{ padding: "20px" }}>Loading community members...</p>
            ) : error ? (
              <p style={{ padding: "20px", color: "#e0432c" }}>{error}</p>
            ) : (
              <table className="cml-table">
                <thead>
                  <tr>
                    <th className="cml-checkbox-col">
                      <label className="cml-select-all">
                        <input type="checkbox" checked={selectAll} onChange={toggleAll} />
                        <span>Select All</span>
                      </label>
                    </th>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Designation</th>
                    <th>Company</th>
                    <th>Contact</th>
                    <th>Personal Email</th>
                    <th>Official Email</th>
                    <th>Industry</th>
                    <th>Gender</th>
                    <th>LinkedIn</th>
                    <th>State</th>
                    <th>City</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {members.length === 0 ? (
                    <tr>
                      <td colSpan={14} style={{ padding: "20px", textAlign: "center" }}>
                        No community members yet.
                      </td>
                    </tr>
                  ) : (
                    members.map((m, index) => (
                      <tr key={m.id}>
                        <td className="cml-checkbox-col">
                          <input
                            type="checkbox"
                            checked={selected.includes(m.id)}
                            onChange={() => toggleOne(m.id)}
                          />
                        </td>
                        <td>{(currentPage - 1) * pageSize + index + 1}</td>
                        <td>
                          <div className="cml-user-cell">
                            {m.imagePath ? (
                              <img
                                src={`${API_BASE_URL}${m.imagePath}`}
                                alt={m.fullName}
                                className="cml-avatar cml-avatar--photo"
                              />
                            ) : (
                              <span className="cml-avatar">{m.fullName?.charAt(0)}</span>
                            )}
                            {m.fullName}
                          </div>
                        </td>
                        <td>{m.designation}</td>
                        <td>{m.company}</td>
                        <td>{m.contact}</td>
                        <td>{m.personalEmail}</td>
                        <td>{m.officialEmail}</td>
                        <td>{m.industry}</td>
                        <td>{m.gender}</td>
                        <td>
                          {m.linkedIn ? (
                            <a href={m.linkedIn} target="_blank" rel="noreferrer" className="cml-link">
                              View Profile
                            </a>
                          ) : (
                            "—"
                          )}
                        </td>
                        <td>{m.state}</td>
                        <td>{m.city}</td>
                        <td>
                          <div className="cml-row-actions">
                            <button
  className="cml-icon-btn cml-icon-btn--edit"
  onClick={() => openEditModal(m)}
>
  <Pencil size={13} />
  Edit
</button>
 <button
  className="cml-icon-btn cml-icon-btn--delete"
  onClick={() => handleDelete(m.id)}
>
  <Trash2 size={13} />
  Delete
</button>
            {/* ---------------- Delete Confirm Modal ---------------- */}
{deleteTarget !== null && (
  <div className="cml-modal-overlay" onClick={cancelDelete}>
    <div className="cml-confirm-modal" onClick={(e) => e.stopPropagation()}>
      <h3 className="cml-confirm-title">Delete Community Member?</h3>
      <p className="cml-confirm-text">
        Are you sure you want to delete this member? This action cannot be undone.
      </p>
      <div className="cml-confirm-actions">
        <button className="cml-confirm-btn cml-confirm-btn--no" onClick={cancelDelete}>
          No
        </button>
        <button className="cml-confirm-btn cml-confirm-btn--yes" onClick={handleDelete}>
          Yes, Delete
        </button>
      </div>
    </div>
  </div>
)}
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            )}
            </div>
          </div>

          <div className="cml-table-footer">
            <span>
              Showing {members.length === 0 ? 0 : (currentPage - 1) * pageSize + 1}
              &ndash;
              {(currentPage - 1) * pageSize + members.length} of {totalMembers} Members
            </span>
            <div className="cml-pagination">
              <button
                className="cml-page-btn"
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                <ChevronLeft size={14} />
              </button>
              {getPageNumbers().map((p, i) =>
                p === "dots-start" || p === "dots-end" ? (
                  <span key={`${p}-${i}`} className="cml-page-dots">
                    …
                  </span>
                ) : (
                  <button
                    key={p}
                    className={`cml-page-btn${p === currentPage ? " active" : ""}`}
                    onClick={() => goToPage(p)}
                  >
                    {p}
                  </button>
                )
              )}
              <button
                className="cml-page-btn"
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                <ChevronRight size={14} />
              </button>
            </div>
          </div>
        </section>
      </main>

      {/* ---------------- Add Modal ---------------- */}
      {addingOpen && (
        <div className="cml-modal-overlay" onClick={closeAddModal}>
          <div className="cml-modal" onClick={(e) => e.stopPropagation()}>
            <h2 className="cml-modal-title">Add New Community Member</h2>
            <form onSubmit={handleAddSubmit} className="cml-modal-form">
              {memberFields.map((f) => (
                <div className="cml-modal-field" key={f.name}>
                  <label>{f.label}</label>
                  <input
                    type={f.type}
                    name={f.name}
                    value={addForm[f.name] || ""}
                    onChange={handleAddChange}
                    required
                  />
                </div>
              ))}
              <div className="cml-modal-actions">
                <button type="button" className="cml-modal-btn cml-modal-btn--cancel" onClick={closeAddModal}>
                  Cancel
                </button>
                <button type="submit" className="cml-modal-btn cml-modal-btn--save" disabled={saving}>
                  {saving ? "Saving..." : "Add Member"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ---------------- Edit Modal ---------------- */}
      {editingMember && (
        <div className="cml-modal-overlay" onClick={closeEditModal}>
          <div className="cml-modal" onClick={(e) => e.stopPropagation()}>
            <h2 className="cml-modal-title">Edit Community Member</h2>
            <form onSubmit={handleEditSubmit} className="cml-modal-form">
              {memberFields.map((f) => (
                <div className="cml-modal-field" key={f.name}>
                  <label>{f.label}</label>
                  <input
                    type={f.type}
                    name={f.name}
                    value={editForm[f.name] || ""}
                    onChange={handleEditChange}
                    required
                  />
                </div>
              ))}
              <div className="cml-modal-actions">
                <button type="button" className="cml-modal-btn cml-modal-btn--cancel" onClick={closeEditModal}>
                  Cancel
                </button>
                <button type="submit" className="cml-modal-btn cml-modal-btn--save" disabled={saving}>
                  {saving ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}